






































































































import {API} from '@/services/api/api';
import {Vue, Component} from 'vue-property-decorator';
import {mapActions} from 'vuex';
import {getImage, Utils} from '@/utils/Utils';
import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import InsapectionList from '@/components/InspectionListComponent.vue';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import canvasMerge from '@/utils/CanvasMerge';

@Component({
  components: {
    Paginition,
    FilterMenu,
    InsapectionList,
  },
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class InspectionLocate extends Vue {
  showErrorToast: any;
  newInspectionList = [];
  cropper = null;
  deckDots = [];
  showSuccessToast: any;
  inspectionList = [];
  isScreenLoading = true;
  deckId: string = null;
  showBySelectedArea = false;
  deckImageUrl = '';
  deckImgLoader = false;
  deckImgKey = null;
  createdDeckImageUrl = null;
  allInspections: [];
  inspectionKey = 1;
  isImageLoaded = false;

  X1: number = null;
  Y1: number = null;
  X2: number = null;
  Y2: number = null;

  myCanvasStyle = {
    height: 20,
    width: 20,
  };
  deckCanvasImg: any;
  locateInspectionId = this.$route.params.id;
  params = {};

  mounted() {
    this.getInspectionList();
    this.$nextTick(() => {
      this.deckCanvasImg = new Image();
      this.deckCanvasImg.setAttribute('crossOrigin', 'Anonymous');
      this.deckCanvasImg.onload = this.onDeckLoadOnCanvas;
    });
  }

  async getInspectionList() {
    try {
      const params = {
        LocateInspectionId: this.locateInspectionId,
      };
      this.inspectionList = [];

      const response = await API.getInspectionList(params);
      if (response.data) {
        const data = response.data;
        this.inspectionList = data;
        this.inspectionKey = 1 + this.inspectionKey;
        // let newResponse = this.inspectionList.map((me) => {
        //   return {shipId: me.shipID, deckId: me.deckID};
        // });
        const deck = response.deck;
        this.deckId = deck.drawingId;

        this.deckImageUrl = await getImage(deck.imagePath);
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.showErrorToast({msg: 'Networ error'});
      }
      //
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      //
      this.isScreenLoading = false;
    }
  }

  async getInspectionListByArea() {
    try {
      this.inspectionList = [];
      let inspectionFind = [];
      this.deckDots.map((dot) => {
        if (dot.x >= this.X1 && dot.x <= this.X2 && dot.y >= this.Y1 && dot.y <= this.Y2) {
          const findedIndots: any = this.allInspections.find((ins: any) => ins.inspectionID == dot.inspectionID);
          if (findedIndots) {
            inspectionFind.push(findedIndots);
          }
        }
      });
      this.inspectionList = inspectionFind;
      this.inspectionKey = 1 + this.inspectionKey;
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.isScreenLoading = false;
    }
  }
  onDeckLoadOnCanvas() {
    this.myCanvasStyle = {
      height: this.deckCanvasImg.height,
      width: this.deckCanvasImg.width,
    };
  }

  onDeckLoad() {
    //
    this.distroyCropper();
    const t = this.$refs.deckImageRef as HTMLImageElement;
    const _this = this;
    this.cropper = new Cropper(t, {
      autoCrop: false,
      crop() {
        const data = this.cropper.getData(true);

        _this.X1 = data.x;
        _this.Y1 = data.y;
        _this.X2 = data.x + data.width;
        _this.Y2 = data.y + data.height;
      },
      preview: document.getElementById('ppppp'),
      viewMode: 2,
      zoomable: false,
    });
  }

  distroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  onInspectByAreaClick() {
    this.onDeckLoad();
    this.showBySelectedArea = true;
  }

  onBySelectedAreaClick() {
    // this.createdDeckImageUrl = null;
    //

    this.getInspectionListByArea();
  }
  onShowAllInspectionClick() {
    this.inspectionList = [];
    this.inspectionList = this.allInspections;
    this.inspectionKey = 1 + this.inspectionKey;
  }

  // Get all inspection

  async onDeckImgLoad() {
    if (!this.isImageLoaded) {
      let response = this.inspectionList.map((me) => {
        return {shipId: me.shipID, deckId: me.deckID};
      });
      if (response !== [] && response.length > 0 && this.createdDeckImageUrl == null) {
        if (response[0].shipId && response[0].deckId) {
          await this.getAllInspection(response);
        }
      }
    }
    this.isImageLoaded = true;
  }

  async getAllInspection(data) {
    try {
      this.newInspectionList = [];

      const param = {
        ShipId: data[0].shipId,
        DeckId: data[0].deckId,
        // ShipId: null,

        FromDate: null,
        EndDate: null,
      };
      const response = await API.getInspectionListByShip(param);
      if (response.data) {
        this.newInspectionList = response.data;
        this.allInspections = response.data;
        // this.renderDot;

        //

        this.renderDotDeck();
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.showErrorToast({msg: 'Network error'});
      }
      //
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network error'});
      //
    } finally {
      this.isScreenLoading = false;
    }
  }
  renderDotDeck() {
    this.deckImgLoader = true;

    this.deckDots = [];

    if (this.deckImageUrl && this.inspectionList.length > 0) {
      let imageRef = this.$refs.deckImageRef as HTMLImageElement;
      this.newInspectionList.map((inspection) => {
        const points = inspection.additionalInfo;
        //  const inspectionPoint = inspection.inspectionPoint;

        // let y = inspectionPoint.location_Y;
        // let x= inspectionPoint.location_X;
        let y = (points.centerFrom + points.centerUpto) / 2;

        if (points.centerFrom === null || points.centerUpto === null) {
          this.showErrorToast({msg: 'Center From and Center upto not found'});
        } else if (points.frameUpto === null || points.frameFrom === null) {
          this.showErrorToast({msg: 'Frame From and Frame upto not found'});
        } else {
          // let y = (points.centerFrom + points.centerUpto) / 2;
          let x,
            y = null;
          if (inspection.isMisc) {
            y = (points.centerFrom + points.centerUpto) / 2;
            let totalFrame = points.frameUpto - points.frameFrom;
            let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
            let pixelsInEachframes = pixelsCountInZone / totalFrame;
            let thisframePosition = points.frameUpto - inspection.frameNumber;
            let framePosition = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
            x = framePosition;
          } else {
            y = points.location_Y;
            x = points.location_X;
          }
          //
          this.deckDots.push({
            x: x,
            y: y,
            radius: 0.003 * imageRef.naturalWidth,
            color: Utils.getBackgroundColor(inspection.severity),
            inspectionID: inspection.inspectionID,
            inspectionCode: inspection.inspectionCode,
          });
          //
        }
      });
      this.mergeImage();
    }
  }
  mergeImage() {
    let img = this.deckImageUrl;
    let dots = this.deckDots;

    //
    canvasMerge(img, dots, {
      crossOrigin: 'anonymous',
      drawType: 'circle',
    }).then((b64) => {
      this.deckImgLoader = false;
      if (b64 && b64.length > 8) {
        this.createdDeckImageUrl = b64;
      }
      this.$forceUpdate();
      // setTimeout(() => {

      // }, 2000);

      // this.initDriftZoom();
    });
  }
}
